import { Controller } from "@hotwired/stimulus"

// "Hear it" button for the music-theory-short instrument + ambience pickers.
// Fetches a short cached WAV (one chord in the chosen sound/space) from the
// instrument_sample endpoint and plays it in-page. Selecting a new sound while
// a sample is playing stops the old one.
export default class extends Controller {
  static targets = ["instrument", "ambience", "button"]
  static values = { url: String }

  disconnect() {
    this.stop()
  }

  play() {
    this.stop()

    const params = new URLSearchParams({ instrument: this.instrumentValueFor() })
    const ambience = this.ambienceValueFor()
    if (ambience) params.set("ambience", ambience)

    this.audio = new Audio(`${this.urlValue}?${params.toString()}`)
    this.setButtonLabel("Loading…")
    this.audio.addEventListener("playing", () => this.setButtonLabel("Playing…"))
    this.audio.addEventListener("ended", () => this.reset())
    this.audio.addEventListener("error", () => this.reset())
    this.audio.play().catch(() => this.reset())
  }

  stop() {
    if (this.audio) {
      this.audio.pause()
      this.audio = null
    }
    this.reset()
  }

  reset() {
    this.setButtonLabel(this.defaultLabel())
  }

  instrumentValueFor() {
    return this.hasInstrumentTarget ? this.instrumentTarget.value : ""
  }

  ambienceValueFor() {
    return this.hasAmbienceTarget ? this.ambienceTarget.value : ""
  }

  defaultLabel() {
    if (!this.originalLabel && this.hasButtonTarget) {
      this.originalLabel = this.buttonTarget.textContent.trim() || "Hear it"
    }
    return this.originalLabel || "Hear it"
  }

  setButtonLabel(label) {
    this.defaultLabel() // capture the original before the first overwrite
    if (this.hasButtonTarget) this.buttonTarget.textContent = label
  }
}
